

































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateBranchProfileDetailsRequest from '@/models/Branches/UpdateBranchProfileDetailsRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BranchDto from '@/models/Branches/BranchDto';


@Component({
    name: 'BranchProfileDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new BranchDto();

@Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentBranch));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateBranchProfileDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.biography = this.entity.biography;
    request.website = this.entity.website;
    request.brandName = this.entity.brandName;
    request.phoneNumber = this.entity.phoneNumber;
    
    await AgencySettingsModule.editBranchProfileDetails(request)
    this.dialog = false;
  }
}
